export default function simpleFilename(filename) {
	if(!filename) {
		return '';
	}

	return filename.toLowerCase().trim().replace(/[`’']/g, '');
}